import useDateFormatters from "@hooks/useDateFormatters"

import { faIcon } from "@utils/faIcon"
import { formatRelativeTimeShort } from "@utils/relativeTime"

import { Badge } from "@atoms"

import { LastModifiedBadgeProps } from "./LastModifiedBadge.types"

const icon = faIcon({ name: "clock", style: "regular" })

export default function LastModifiedBadge(props: LastModifiedBadgeProps) {
    const { date, size = "md", label = "Last modified" } = props

    const { formatDatetimeTooltip } = useDateFormatters()

    if (!date) {
        return null
    }

    const relative = formatRelativeTimeShort(date)
    const tooltip = formatDatetimeTooltip(label, date)

    return (
        <Badge size={size} variant="icon" icon={icon} tooltip={tooltip}>
            {relative}
        </Badge>
    )
}
